import { Select, SelectProps } from 'antd'
import cls from 'classnames'
import styles from './ASelect.module.less'
import AIcon from '../AIcon/AIcon'

type Props = Pick<
  SelectProps,
  | 'allowClear'
  | 'options'
  | 'defaultValue'
  | 'placeholder'
  | 'value'
  | 'onChange'
  | 'onClear'
  | 'onClick'
  | 'onFocus'
  | 'onBlur'
  | 'onSelect'
  | 'mode'
  | 'optionRender'
  | 'dropdownRender'
  | 'dropdownStyle'
  | 'labelRender'
  | 'menuItemSelectedIcon'
  | 'open'
> & {
  className?: string
  testId?: string
}

const COMPONENT_NAME = 'A-Select'
function ASelect(props: Props) {
  const { testId, className, menuItemSelectedIcon, ...selectProps } = props
  const classNames = cls(styles[COMPONENT_NAME], className)
  const popupClassName = cls(styles['A-Select-popup'], testId && `${testId}-popup`)
  return (
    <Select
      {...selectProps}
      data-testid={testId}
      tagRender={multipleRender}
      className={classNames}
      variant='borderless'
      suffixIcon={<DownIcon />}
      popupClassName={popupClassName}
      menuItemSelectedIcon={menuItemSelectedIcon || <SelectIcon />}
    ></Select>
  )
}

export function DownIcon() {
  return <AIcon style={{ pointerEvents: 'none' }} className={styles.downIcon} width={15} height={15} type='icon-line-global_down' />
}

function SelectIcon() {
  return <AIcon className={styles.selectIcon} type='icon-line-global_check' />
}

function multipleRender(props: {
  label: React.ReactNode
  // value: any;
  // disabled: boolean;
  // onClose: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  // closable: boolean;
  // isMaxTag: boolean;
}) {
  return (
    <span style={{ display: 'inline-block', height: '100%', paddingLeft: 2, paddingRight: 2 }}>
      {props.label}
    </span>
  )
}

export default ASelect
